import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AlertService } from './alerts.service';
import { IAlerts } from './alert/alert.interface';

@Component({
    selector: 'mlp-ng-alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.scss']
})

export class AlertsSharedComponent {
    @Input() alerts: Array<IAlerts>;

    constructor(public alertService: AlertService) {}

    removeAlert(alert: IAlerts): void {
        this.alertService.removeAlert(alert);
    }
}
